export default __webpack_public_path__ + "static/media/what-we-provide-userexperience-icon.a4fec98a.svg";